
import type { Migration } from ".";

const migration: Migration = {
  applyToVersions: "<3.0.0-alpha.41",
  type: "before",
  name: "decrease the net min scale",
  migrate: (data: {
    net?: { minScale: number }
  }) => {
    if (data.net) {
      data.net.minScale = 0.1;
    }

    return data;
  }
};

export default migration;
